import { render } from "./vresourcesedit.vue?vue&type=template&id=b170687a&scoped=true"
import script from "./vresourcesedit.vue?vue&type=script&lang=js"
export * from "./vresourcesedit.vue?vue&type=script&lang=js"

import "./vresourcesedit.vue?vue&type=style&index=0&id=b170687a&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b170687a"]])

export default __exports__